module.exports = __webpack_public_path__ + "static/media/elegir_xEN.abd62361.svg";